import { gsap } from "../global/gsap";

const initShortCourseHero = (ticker) => {
    const items = Array.from(ticker.querySelectorAll('.js-item'));

    if (!items.length) return;

    const itemWidth = items[0].offsetWidth;

    // const itemsNeeded = Math.ceil((window.innerWidth * 2) / itemWidth) + 1;
    const itemsNeeded = 6;

    // Clone items until we have enough
    while (ticker.children.length < itemsNeeded) {
        items.forEach(item => {
            ticker.appendChild(item.cloneNode(true));
        });
    }

    const totalWidth = itemWidth * items.length;


    // Animate
    gsap.to(ticker, {
        x: -totalWidth,
        duration: 80,
        ease: 'none',
        repeat: -1,
        modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
        }
    });
};

export { initShortCourseHero as default };
